import { Item, SkeletonWrapper } from "./TableSkeleton.styled";

const TableSkeleton = ({ rowStyles }) => {
  return (
    <SkeletonWrapper>
      {rowStyles.map(({ width, height }, i) => (
        <Item width={width} height={height} key={i} />
      ))}
    </SkeletonWrapper>
  );
};

export default TableSkeleton;
